import React, { useState, useEffect } from "react";
import { BsDashLg } from "react-icons/bs";
import Step1Identification from "./Step1_Identification";
import IdentificationForm from "../Forms/IdentificationForm";
import ContactForm from "../Forms/ContactForm";
import Step4Profil from "./Step4_profil";
import StepActivite from "./StepActivite";
import axios from "axios";
import { registerUrl } from "../../../Url";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Stepper = () => {
  const [stepper, setStepper] = useState(2);
  const [step1Identification, setStep1Identification] = useState({});
  const [identificationForm, setIdentificationForm] = useState({});
  const [contactForm, setContactForm] = useState({});
  const [activiteForm, setActiviteForm] = useState({});
  const [step4Profil, setStep4Profil] = useState({});
  const [forms, setForms] = useState({});
  //const registerurl ="http://localhost:8000/api/register"
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(window?.localStorage.getItem("userData") ?? "{}");
  const navigate = useNavigate();
  const [step1Valid, setStep1Valid] = useState(false)
  const [step2Valid, setStep2Valid] = useState(false)
  const [step3Valid, setStep3Valid] = useState(false)
  const [step4Valid, setStep4Valid] = useState(false)
  const [step5Valid, setStep5Valid] = useState(false)

  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    window.localStorage.clear();
  }, []);

  const handleNext = () => {
    if (stepper >= 1 && stepper < 5) {
      setStepper(stepper + 1);
    }
  };
  const handlePrevious = () => {
    if (stepper >= 2 && stepper <= 5) {
      setStepper(stepper - 1);
    }
  };

  function formsData(data) {
    setForms(data);
  }

  function step1IdentificationData(data) {
    setStep1Valid(data.isValid)
    setStep1Identification(data);
  }

  function identificationFormData(data) {
    setStep2Valid(data.isValid)
    setIdentificationForm(data);
  }
  function contactFormData(data) {
    setStep3Valid(data.isValid)
    setContactForm(data);
  }
  function step4ProfilData(data) {
    console.log(data)
    setStep5Valid(data.isValid)
    setStep4Profil(data);
  }

  function activiteFormData(data) {
    setStep4Valid(data.isValid)
    setActiviteForm(data);
  }

  function handleSubmit() {
    const data = {
      ...step1Identification,
      ...identificationForm,
      ...contactForm,
      ...activiteForm,
      ...step4Profil,
      ...forms,
  };

    setSubmit(true);
    axios
      .post(registerUrl, data)
      .then((response) => {
        console.log(response);
        setLoading(true);
        setSubmit(true);
      })
      .catch((err) => {
        const errors = err?.response?.data;
        let message = "";
        if(errors){
          Object.values(errors).forEach(item =>{
            if(typeof item ==="string"){
              message = item+"\n";
            }
          })
        } 
        else{
          message = "Une erreur s'est produite. Veuillez contacter un administrateur!";
        }
        console.log(err?.response?.data);
        if(message.includes('swiftmailer')){
          message = "Impossible de contacter le serveur. Veuillez contacter un administrateur!";
        }
        alert(message);
        setLoading(false);
        setSubmit(false);
      });

    console.log(data, "all");
  }

  return (
    <div className="mb-5">
      <div className="steps">
        {/* <span
          className={`${
            stepper == 1
              ? "activeStep"
              : stepper > 1
              ? "doneStep"
              : "unDoneStep"
          } px-sm-4 py-sm-2 `}
        >
          1<span className="step-title">- Mon besoin</span>
        </span>
        <BsDashLg className="text-white" /> */}
        <span
          className={`${
            stepper == 2
              ? "activeStep"
              : stepper > 2
              ? "doneStep"
              : "unDoneStep"
          } px-sm-4 py-sm-2 `}
        >
          1<span className="step-title">- Mes informations</span>
        </span>
        <BsDashLg className="text-white" />
        <span
          className={`${
            stepper == 3
              ? "activeStep"
              : stepper > 3
              ? "doneStep"
              : "unDoneStep"
          } px-sm-4 py-sm-2 `}
        >
          2<span className="step-title">- Mes contacts</span>
        </span>
        <BsDashLg className="text-white" />
        <span
          className={`${
            stepper == 4
              ? "activeStep"
              : stepper > 4
              ? "doneStep"
              : "unDoneStep"
          } px-sm-4 py-sm-2 `}
        >
          3<span className="step-title">- Activités JPO</span>
        </span>
        <BsDashLg className="text-white" />
        <span
          className={`${
            stepper == 5
              ? "activeStep"
              : stepper > 5
              ? "doneStep"
              : "unDoneStep"
          } px-sm-4 py-sm-2 `}
        >
          4<span className="step-title">- Mon profil</span>
        </span>
      </div>
      <div className="bg-white text-start rounded p-4 mt-3">
        {loading && (
          <div className="rendu mt-3">
          Votre demande de rdv aux JPO a été prise en compte. Veuillez vérifier votre boîte mail svp !
          </div>
        )}
        {!loading && (
          <>
            <div className="rendu mt-3">
              {/* {stepper == 1 && (
                <Step1Identification
                  step1Identification={step1Identification}
                  step1IdentificationData={step1IdentificationData}
                />
              )} */}
              {stepper == 2 && (
                <IdentificationForm
                  identificationForm={identificationForm}
                  identificationFormData={identificationFormData}
                />
              )}
              {stepper == 3 && (
                <ContactForm
                  contactForm={contactForm}
                  contactFormData={contactFormData}
                />
              )}
              {stepper == 4 && (
                <StepActivite
                  activiteForm={activiteForm}
                  activiteFormData={activiteFormData}
                />
              )}
              {stepper == 5 && (
                <Step4Profil
                  step4Profil={step4Profil}
                  step4ProfilData={step4ProfilData}
                  forms={forms}
                  formsData={formsData}
                />
              )}
            </div>

            <div className="my-3">
              {stepper == 2 && step2Valid ? (
                <div className="text-end">
                  <button className="btn-step" onClick={handleNext}>
                    Suivant
                  </button>
                </div>
              ) : stepper > 1 && stepper < 5? (
                <div className="d-flex justify-content-between">
                  {step2Valid && (
                    <button className="btn-step" onClick={handlePrevious}>
                      Retour
                    </button>
                  )}
                  {stepper === 2 && step2Valid && (
                    <button className="btn-step" onClick={handleNext}>
                      Suivant
                    </button>
                  )}
                  {stepper === 3 && step3Valid && (
                    <button className="btn-step" onClick={handleNext}>
                      Suivant
                    </button>
                  )}

                  {stepper === 4 && step4Valid && (
                    <button className="btn-step" onClick={handleNext}>
                      Suivant
                    </button>
                  )}

                  {stepper === 5 && step5Valid && (
                    <button className="btn-step" onClick={handleNext}>
                      Suivant
                    </button>
                  )}
                  
                </div>
              ) : (
                <div className="d-flex justify-content-between">
                  {step2Valid && (
                    <button className="btn-step" onClick={handlePrevious}>
                      Retour
                    </button>
                  )}
                  {submit && (
                    <button className="btn-soumission" disabled>
                      Patientez...
                    </button>
                  )}
                  {!submit && step2Valid && step3Valid && step4Valid && (
                    <button className="btn-soumission" onClick={handleSubmit}>
                      Soumettre
                    </button>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Stepper;